import React from 'react';

export default function Circle(props) {
  return (
    <div className={`w-20 h-20 sm:w-36 sm:h-36 absolute right-5 -top-16 sm:-top-24 rounded-full ${props.color}`}></div>
  )
}
